import { OpenXmlPart } from './openXmlPart';
import { RichText } from './richText';
import type { XlsxFile } from './xlsxFile';

export class SharedStrings extends OpenXmlPart {
  public readonly strings: (string | RichText)[] = [];

  constructor(filePath: string, originalXml: string, xlsxFile: XlsxFile) {
    super(filePath, originalXml, xlsxFile);

    if (xlsxFile.sharedStrings) {
      throw new Error('Shared strings already exist');
    }
    xlsxFile.sharedStrings = this;

    const strings = this.dom.getElementsByTagName('si');
    for (const string of strings) {
      if (string.getElementsByTagName('r').length) {
        this.strings.push(new RichText(string));
      } else {
        this.strings.push(string.textContent!);
      }
    }
  }
}
